webpackJsonp([36],{

/***/ "m5ZQ":
/***/ (function(module, exports, __webpack_require__) {

var mariSmithTutorials = (function () {
    function mariSmithTutorials() {
    }
    return mariSmithTutorials;
}());
angular.module('animatronApp.wave.mariSmithTutorials', []).component('mariSmithTutorials', {
    controller: mariSmithTutorials,
    templateUrl: __webpack_require__("wL/W")
});


/***/ }),

/***/ "wL/W":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/mari-smith-tutorials_05ff7f4953807183796abef5a72cc656.html";

/***/ })

});


// WEBPACK FOOTER //
// javascripts/36-c7c98a0cc108ea8b91f3.min.js